import React from "react";
import { Field } from "react-final-form";
import { Toggle } from "react-powerplug";
import Popover from "@govlaunch/popover";
import * as palette from "@govlaunch/palette";
import Resources from "~/components/form/resources/Resources";
import ResourceForm from "~/components/form/resources/ResourcesForm";
import { IFormFieldProps } from "~/components/form/FormFieldProps";
import { FormattedMessage } from "react-intl";

export default function ResourcesField({ fieldName }: IFormFieldProps) {
  return (
    <Field name={fieldName}>
      {({ input }) => (
        <>
          <Resources
            resources={input.value}
            onRemove={(resource) => {
              const nextResources = input.value.filter((maybeResource: any) => maybeResource !== resource);

              input.onChange(nextResources);
            }}
          />
          <Toggle>
            {({ on: isOpen, toggle }) => (
              <Popover
                boxStyle={{
                  boxShadow: "rgba(34, 35, 40, 0.2) 0px 10px 49px 0px",
                }}
                onClickOutside={() => {
                  const filestackIsOpen = document.getElementById("__filestack-picker");

                  if (!filestackIsOpen) {
                    toggle();
                  }
                }}
                placement="top"
                isOpen={isOpen}
                render={() => (
                  <ResourceForm
                    onSubmit={(resource) => {
                      input.onChange(input.value.concat(resource));

                      toggle();
                    }}
                    onClose={toggle}
                    allowText={true}
                  />
                )}
              >
                {({ innerRef }: { innerRef: React.RefObject<HTMLSpanElement> }) => (
                  <span
                    css={{
                      color: palette.primary,
                      textTransform: "uppercase",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 14,
                      cursor: "pointer",
                      border: `solid 1px ${palette.lightestGray}`,
                      minHeight: 40,
                      "&:hover": {
                        opacity: 0.8,
                      },
                    }}
                    ref={innerRef}
                    role="button"
                    onClick={toggle}
                  >
                    <FormattedMessage defaultMessage="Add Resource" id="A0sFkU" />
                  </span>
                )}
              </Popover>
            )}
          </Toggle>
        </>
      )}
    </Field>
  );
}
